export default __webpack_public_path__ + "static/media/orderManagerImg.d3b14518.webp";